import React, { useState, useEffect } from 'react';
import { useConversation } from '@11labs/react';
//import logo from '../imgs/otc2.png';
import logo from '../imgs/logos.png';
import { Link } from 'react-router-dom';

const ElevenLabsIntegration = ({ agentId }) => {
  const [microphoneAccessGranted, setMicrophoneAccessGranted] = useState(false);
  const [volume, setVolume] = useState(0.5);
  const { startSession, endSession, setVolume: setConversationVolume, status, isSpeaking } = useConversation({
    onConnect: () => console.log('Connessione stabilita'),
    onDisconnect: () => console.log('Connessione terminata'),
    onMessage: (message) => console.log('Nuovo messaggio ricevuto:', message),
    onError: (error) => console.error('Errore:', error),
  });

  useEffect(() => {
    const checkMicrophonePermission = async () => {
      try {
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
        setMicrophoneAccessGranted(permissionStatus.state === 'granted');
        
        permissionStatus.onchange = () => {
          setMicrophoneAccessGranted(permissionStatus.state === 'granted');
        };
      } catch (error) {
        console.error('Errore nel controllo del permesso del microfono:', error);
      }
    };

    checkMicrophonePermission();
  }, []);

  const requestMicrophoneAccess = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicrophoneAccessGranted(true);
    } catch (error) {
      console.error('Accesso al microfono negato:', error);
      setMicrophoneAccessGranted(false);
    }
  };

  const handleStartConversation = async () => {
    try {
      await startSession({ 
        agentId, 
        timeout: 30000
      });
      console.log('Sessione avviata con agente pubblico');
    } catch (error) {
      console.error('Errore nell\'avvio della conversazione:', error);
    }
  };

  const handleEndConversation = async () => {
    try {
      await endSession();
    } catch (error) {
      console.error('Errore nella terminazione della conversazione:', error);
    }
  };

  const handleVolumeChange = async (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    await setConversationVolume({ volume: newVolume });
  };

  return (
    <div className="elevenlabs-container">
      <img 
        src={logo} 
        alt="logo" 
        className="logo" 
        //onClick={() => window.open('https://www.otacon.it/home-agency-2/', '_blank')} 
        onClick={() => window.open('https://www.salespark.it/', '_blank')}
        style={{ cursor: 'pointer' }} 
      />
      {!microphoneAccessGranted ? (
        <button className="access-button" onClick={requestMicrophoneAccess}>Concedi accesso al microfono</button>
      ) : (
        <div className="conversation-interface">
          <h2 className="title">cold calling agent AI Demo</h2>
          <p className="status">Stato connessione: <span>{status}</span></p>
          <p className="speaking-status">L'agente sta parlando: <span>{isSpeaking ? 'Sì' : 'No'}</span></p>

          {isSpeaking && <div className="audio-wave"><span></span><span></span><span></span></div>}

          <div className="button-group">
            <button className="start-button" onClick={handleStartConversation}>Avvia Conversazione</button>
            <button className="end-button" onClick={handleEndConversation}>Termina Conversazione</button>
          </div>

          {/*<div className="volume-control">
            <label htmlFor="volume">Volume:</label>
            <input
              type="range"
              id="volume"
              min="0"
              max="1"
              step="0.01"
              value={volume}
              onChange={handleVolumeChange}
            />
          </div>*/}
          <div className='back-button'>
            <Link to="/">Torna alla home</Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ElevenLabsIntegration;